import { DateRangeOption } from '../enum/Dashboard.enum';
import { startOfDay, endOfDay, startOfMonth, startOfWeek, subDays, format } from 'date-fns';

// Rango por defecto de Liquidaciones: hoy y los 6 días anteriores.
export const LAST_DAYS_DEFAULT_RANGE = 7;

export const getDateRange = (option: DateRangeOption) => {
  const today = new Date()
  let startDate, endDate

  switch (option) {
    case DateRangeOption.TODAY:
      startDate = startOfDay(today);
      endDate = endOfDay(today)
      break;
    case DateRangeOption.THIS_WEEK:
      startDate = startOfWeek(today, { weekStartsOn: 1 })
      endDate = endOfDay(today)
      break;
    case DateRangeOption.THIS_MONTH:
      // Del día 1 del mes actual a hoy: siempre cae dentro del mismo mes, así que
      // respeta el límite de 31 días que valida el BFF.
      startDate = startOfMonth(today)
      endDate = endOfDay(today)
      break;
      case DateRangeOption.CUSTOM:
        //This values are just placeholders, dates are handled by DateSeclector itself
        startDate = new Date();
        endDate = new Date();
        break;
    default:
      startDate = startOfDay(today);
      endDate = endOfDay(today)
      break;
  }

  return { startDate, endDate };
},

getFormatterDateRange = (start: Date | undefined, end: Date | undefined): {startDate: string, endDate: string} => {
  const pattern = 'dd/MM/yyyy';
  return {
    startDate: start ? format(start, pattern) : pattern.toLowerCase(),
    endDate: end ? format(end, pattern) : pattern.toLowerCase()
  }
},

getFormatToSendApi = (dateRange: {startDate:Date|undefined, endDate:Date|undefined}) => {
  const pattern = 'yyyy-MM-dd';
  return {
    startDate: dateRange.startDate ? format(dateRange.startDate, pattern) : dateRange.startDate,
    endDate: dateRange.endDate ? format(dateRange.endDate, pattern) : dateRange.endDate
  }
},

getLastDaysDateRange = (days: number, today: Date = new Date()): { startDate: Date, endDate: Date } => ({
  startDate: startOfDay(subDays(today, days - 1)),
  endDate: startOfDay(today),
}),

getParseDate = (date: string ): Date => {
  const [year, month, day] = date.split('-').map(Number)
  const localOffset = new Date().getTimezoneOffset() * 60 * 1000

  return new Date(Date.UTC(year, month - 1, day) + localOffset)
}
